<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="800px">
      <v-card class="px-3">
        <v-card-title primary-title class="title">{{presTitle}}</v-card-title>
        <v-card-text class="pa-0">
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-container grid-list-xs fluid>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-select :items="tests" v-model="newTest.tests" label="Select tests " multiple></v-select>
                </v-flex>

                <v-flex xs12 class="text-xs-right mt-3">
                  <v-btn flat @click="clean">Close</v-btn>

                  <v-btn
                    class="mx-0"
                    :loading="loading"
                    color="primary"
                    @click="submit"
                    :disabled="!valid"
                  >Save</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  data() {
    return {
      dialog: false
    };
  }
};
</script>

<style lang="scss" scoped>
</style>